import { LineRange } from 'monaco-editor/esm/vs/editor/common/core/lineRange.js';
import { Range } from 'monaco-editor/esm/vs/editor/common/core/range.js';
function invertLineRange(range, model) {
    if (range.isEmpty) {
        return [];
    }
    const result = [];
    if (range.startLineNumber > 1) {
        result.push(( new LineRange(1, range.startLineNumber)));
    }
    if (range.endLineNumberExclusive < model.getLineCount() + 1) {
        result.push(( new LineRange(range.endLineNumberExclusive, model.getLineCount() + 1)));
    }
    return result.filter(r => !r.isEmpty);
}
function lineRangeAsRange(r) {
    return ( new Range(r.startLineNumber, 1, r.endLineNumberExclusive - 1, 1));
}
export { invertLineRange, lineRangeAsRange };
